import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DropdownMenuSub"], _normalizeProps(_guardReactiveProps($setup.forwarded)), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */));
}
